// مصطلحات تذاكر العملاء — مصدر واحد للبوابة ولصفحة الفريق.
export const REQ_STATUS_AR = {
  new: 'قيد المراجعة',
  awaiting_client: 'بانتظار ردّ العميل',
  assigned: 'جارٍ العمل',
  completed: 'مُنجزة',
  closed: 'مغلقة',
  rejected: 'معتذَر عنها',
};

export const REQ_STATUS_BADGE = {
  new: 'pending',
  awaiting_client: 'revision',
  assigned: 'in_progress',
  completed: 'waiting_approval',
  closed: 'completed',
  rejected: 'cancelled',
};

export const REQ_CATEGORY_AR = {
  inquiry: 'استفسار',
  issue: 'عطل أو مشكلة',
  new_work: 'طلب عمل جديد',
  financial: 'مالي',
  other: 'أخرى',
};

/**
 * متغيّرات الردود الجاهزة — تُستبدل عند إدراج الرد.
 */
export function fillCanned(body, { client, id, title, user }) {
  return String(body)
    .replaceAll('{العميل}', client || '')
    .replaceAll('{رقم}', id != null ? `#${id}` : '')
    .replaceAll('{العنوان}', title || '')
    .replaceAll('{الموظف}', user || '');
}

export const CLOSE_REASON_AR = {
  client_confirmed: 'بتأكيد العميل',
  auto: 'تلقائياً بعد يوم عمل',
  staff: 'إدارياً',
  answered: 'بالرد على الاستفسار',
};
